import React from "react";
import Navbar from "./components/navbar/Navbar";
import Home from "./pages/home/Home";
import Footer from "./components/footer/Footer";
import { Route, Routes } from "react-router-dom";
import About from "./pages/about/About";
import Blogs from "./pages/blogs/Blogs";
import Contact from "./pages/contact/Contact";
import News from "./pages/news/News";
import ScrollToTop from "./ScrollToTop";
import Gallery from "./pages/gallery/Gallery";
import BlogDetail from "./pages/blogs/BlogDetail";
import BlogDetail2 from "./pages/blogs/BlogDetail2";
import Donation from "./pages/donation/Donation";
import CsrInitiatives from "./pages/csr/CsrInitiatives";
import Volunteer from "./pages/volunteer/Volunteer";
import BlogDetails3 from "./pages/blogs/BlogDetails3";
import AgniveerRegistrationForm from "./components/AgniveerRegistrationForm";

// Super Admin
import SuperAdminSessionContainer from "./containers/SuperAdminSessionContainer";
import SuperAdminLogin from "./superadmin/SuperAdminLogin";
import { ToastContainer } from "react-toastify";
import { Toast } from "bootstrap/dist/js/bootstrap.bundle";

// Administration Components
import AddSlider from "./Administration/AddSlider";
import AddNews from "./Administration/AddNews";
import AddBlock from "./Administration/Block";
import AddAwardsRecognitions from "./Administration/AddAwardsRecognition";
import ContactFormEnquiries from "./Administration/ContactFormEnquiries";
import AddLicenceCertificates from "./Administration/AddLicenceCertification";
import AddForeignVisitors from "./Administration/AddForeignVisitors";
import AddProducts from "./Administration/AddProducts";
import AddGallery from "./Administration/AddGallery";
import SuperAdminHome from "./Administration/SuperAdminHome";
import AddTotalCount from "./Administration/AddTotalCount";
import AddAgroProject from "./Administration/AddAgroProject";
import AddDairyProject from "./Administration/AddDairyProject";
import AddCashewProject from "./Administration/AddCashewProject";
import AddGeraniumProject from "./Administration/AddGeraniumProject";
import AddJivamrutProject from "./Administration/AddJivamrutProject";
import AddFisheryProject from "./Administration/AddFisheryProject";
import AddPearlFarmingProject from "./Administration/AddPearlFarmingProject";
import AddBioCngProject from "./Administration/AddBioCngProject";
import AddVermicompostProject from "./Administration/AddVermicompostProject";
import AddProjectsSlider from "./Administration/AddProjectsSlider";
import AddPanchgavyaProject from "./Administration/AddPanchgavyaProject";
import AddEvents from "./Administration/AddEvents";
import AddPaintProject from "./Administration/AddPaintProject";
import AddApicultureProject from "./Administration/AddApicultureProject";
import AddAboutUs from "./Administration/AddAboutUs";
import AddSoilResearchProject from "./Administration/AddSoilResearchProject";
import AgniveerList from "./Administration/AgniveerList";

const App = () => {
  return (
    <>
      <ScrollToTop />
      <ToastContainer {...Toast} />
      <Routes>
        {/* Public Routes with Navbar and Footer */}
        <Route path="/*" element={
          <>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/news" element={<News />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/blogdetail" element={<BlogDetail />} />
              <Route path="/blogdetails2" element={<BlogDetail2 />} />
              <Route path="/blogdetails3" element={<BlogDetails3 />} />
              <Route path="/donation" element={<Donation />} />
              <Route path="/csr" element={<CsrInitiatives />} />
              <Route path="/volunteer" element={<Volunteer />} />
              <Route path="/agniveer-registration" element={<AgniveerRegistrationForm />} />
            </Routes>
            <Footer />
          </>
        } />

        {/* Super Admin Login Route (No Navbar/Footer) */}
        <Route path="/super-admin" element={<SuperAdminLogin />} />

        {/* Super Admin Protected Routes (No Navbar/Footer) */}
        <Route path="/super-admin/*" element={<SuperAdminSessionContainer />}>

          <Route path="adminhome" element={<SuperAdminHome />} />
          <Route path="addslider" element={<AddSlider />} />
          <Route path="addnews" element={<AddNews />} />
          <Route path="addblock" element={<AddBlock />} />
          <Route path="addevents" element={<AddEvents />} />
          <Route path="addawards" element={<AddAwardsRecognitions />} />
          <Route path="enquiries" element={<ContactFormEnquiries />} />
          <Route path="addcertification" element={<AddLicenceCertificates />} />
          <Route path="addforeignvisitors" element={<AddForeignVisitors />} />
          <Route path="addproduct" element={<AddProducts />} />
          <Route path="addgallery" element={<AddGallery />} />
          <Route path="addtotalcount" element={<AddTotalCount />} />

          {/* Project Management Routes */}
          <Route path="addagroproject" element={<AddAgroProject />} />
          <Route path="adddairyproject" element={<AddDairyProject />} />
          <Route path="addcashewproject" element={<AddCashewProject />} />
          <Route path="addgeraniumproject" element={<AddGeraniumProject />} />
          <Route path="addjivamrutproject" element={<AddJivamrutProject />} />
          <Route path="addfisheryproject" element={<AddFisheryProject />} />
          <Route path="addpearlfarmingproject" element={<AddPearlFarmingProject />} />
          <Route path="addbiocngproject" element={<AddBioCngProject />} />
          <Route path="addvermiproject" element={<AddVermicompostProject />} />
          <Route path="addpanchgavyaproject" element={<AddPanchgavyaProject />} />
          <Route path="addpaintproject" element={<AddPaintProject />} />
          <Route path="addprojectslider" element={<AddProjectsSlider />} />
          <Route path="addapicultureproject" element={<AddApicultureProject />} />
          <Route path="addaboutus" element={<AddAboutUs />} />
          <Route path="addsoilresearch" element={<AddSoilResearchProject />} />
          <Route path="agniveerlist" element={<AgniveerList />} />
        </Route>
      </Routes>
    </>
  );
};

export default App;